import { gqlPromise, type DefaultContext } from '@egw/clients'
import { type InvestmentAssetAllocation } from '../../../models'

export const getPortfolioOverviewAssetAllocation = async (
  context?: DefaultContext,
): Promise<InvestmentAssetAllocation | undefined> => {
  const response = (await gqlPromise(
    {
      name: 'portfolioOverviewAssetAllocation',
      query: `
      query portfolioOverviewAssetAllocation {
        wealthOverview {
         personalPortfolio {
            assetAllocation {
              __typename
              equities {
                __typename
                amount {
                  currencyCode
                  amount
                }
                percentage
                holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                sectors {
                  sector
                  percentage
                  amount {
                    currencyCode
                    amount
                  }
                  holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                }
              }
              fixedIncome {
                __typename
                amount {
                  currencyCode
                  amount
                }
                percentage
                holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                categories {
                  category
                  percentage
                  amount {
                    currencyCode
                    amount
                  }
                  holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                }
              }
              cashEquivalent {
                __typename
                amount {
                  currencyCode
                  amount
                }
                percentage
                holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                categories {
                  category
                  percentage
                  amount {
                    currencyCode
                    amount
                  }
                  holdings {
                    amount {
                      currencyCode
                      amount
                    }
                    quantity
                    costBasis {
                      currencyCode
                      amount
                    }
                    symbol
                    name
                  }
                }
              }
              other {
                __typename
                amount {
                  currencyCode
                  amount
                }
                percentage
                holdings {
                  amount {
                    currencyCode
                    amount
                  }
                  quantity
                  symbol
                  name
                }
              }
              preference {
                equities
                fixedIncome
                cashEquivalent
              }
            }
          }
        }
      }
      `,
    },
    context,
  )) as {
    wealthOverview: {
      personalPortfolio: {
        assetAllocation: InvestmentAssetAllocation
      }
    }
  }
  return response.wealthOverview.personalPortfolio.assetAllocation as unknown as InvestmentAssetAllocation
}
